/* eslint-disable no-console */
import i18next from 'I18n'

export const formatMessage = (key) => {
  switch (key) {
    case 'INVITE_NOT_FOUND': {
      return i18next.t('error_message:INVITE_NOT_FOUND')
    }
    case 'USER_NOT_FOUND': {
      return i18next.t('error_message:USER_NOT_FOUND')
    }
    case 'USER_INACTIVE': {
      return i18next.t('error_message:USER_INACTIVE')
    }
    case 'SYSTEM_ERROR': {
      return i18next.t('error_message:SYSTEM_ERROR')
    }
    case 'REQUEST_NOT_FOUND': {
      return i18next.t('error_message:REQUEST_NOT_FOUND')
    }
    case 'CHANGE_EMAIL_INVALID': {
      return i18next.t('error_message:CHANGE_EMAIL_INVALID')
    }
    case 'INVITE_PASSWORD_INVALID': {
      return i18next.t('error_message:INVITE_PASSWORD_INVALID')
    }
    case 'RESET_TOKEN_EXPIRE_OR_INVALID': {
      return i18next.t('error_message:RESET_TOKEN_EXPIRE_OR_INVALID')
    }
    case 'VERIFY_EMAIL': {
      return i18next.t('error_message:VERIFY_EMAIL')
    }
    case 'INVITE_SUCCESS': {
      return i18next.t('error_message:INVITE_SUCCESS')
    }
    case 'DELETE_ACCOUNT_SUCCESS': {
      return i18next.t('error_message:DELETE_ACCOUNT_SUCCESS')
    }
    case 'SUPPORT_CONTACT_SUCCESS': {
      return i18next.t('error_message:SUPPORT_CONTACT_SUCCESS')
    }
    default: {
      return key
    }
  }
}
